enum RegistrationFailedReason {
    EmailAlreadyTaken = 'email-already-taken',
    PasswordsDontMatch = 'passwords-dont-match',
    Other = 'other'
}


export {
    RegistrationFailedReason
}